/**
 * My Docs -> Share Link modal API (Sendlinx_My_Docs_Share_Link_Developer_Specification.docx §8).
 * Backend: sendlinxapi ShareLinkController (context, validate) and UserController@shareLink (send).
 */
import axios from "axios";
import Config from "../../../../../Config";

const unwrap = (res) => {
    const data = res && res.data ? res.data : {};
    if(data.code === undefined || data.code === 200){
        return data.body !== undefined ? data.body : data;
    }
    throw (data.body || { message: "Invalid response from api." });
};
const unwrapError = (err) => {
    if(err && err.response && typeof(err.response) === "object" && err.response.data){
        return err.response.data.body || err.response.data;
    }
    return err;
};
const request = (method, path, { data = null, source = null } = {}) => {
    const options = { url: Config.getApiUrl()+path, method: method, headers: Config.getApiHeaders() };
    if(data !== null){ options.data = JSON.stringify(data); }
    if(source !== null){ options.cancelToken = source.token; }
    return axios(options).then(unwrap).catch(err => { throw unwrapError(err); });
};

/** Random key so a repeated Send click or retry of the same share is not sent twice. */
export const newIdempotencyKey = () => {
    try{
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return "sl_"+Array.from(bytes).map(b => b.toString(16).padStart(2, "0")).join("");
    }catch(e){
        return "sl_"+Date.now().toString(36)+Math.random().toString(36).slice(2, 12);
    }
};

const ShareLinkApi = {
    /** Files (canonical My Docs folder), FAR on/off and current link settings for the caller's own link. */
    context(hash, source = null){
        return request("GET", "user/link/"+encodeURIComponent(hash)+"/share-context", { source });
    },
    /**
     * Server-side FAR validation. Returns { status: off|pending|no_rule|passed|review|blocked,
     * perRecipient[], matchedRules[], requiresAuthorization, canAuthorize, verificationRequired, safeUserMessage }.
     */
    validate({ hash, recipients, farEvaluation = null }, source = null){
        const data = { hash, recipients };
        if(farEvaluation){ data.farEvaluation = farEvaluation; }
        return request("POST", "user/link/share/validate", { data, source });
    },
    /** Sends the link (server re-validates). Returns { message, status: "sent", shareId, sent, verificationRequired, verificationForced }. */
    send(data, source = null){
        return request("POST", "user/link/share", { data, source });
    }
};

export default ShareLinkApi;
